var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('AtomButtonArrowRight',{attrs:{"to":_vm.to}},[_vm._v("\n    "+_vm._s(_vm.$t('home.explore'))+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }